import type { ReactNode } from 'react';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeader({ title, subtitle, icon, action }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex items-center justify-center w-9 h-9 rounded-md bg-accent-100 text-accent-700">
            <i className={`${icon} text-lg`}></i>
          </span>
        )}
        <div>
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs md:text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}